import { MonitoringConfig } from "@pages/monitoring-config/monitoring-config";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/monitoring/$modelId/config")({
	component: RouteComponent,
});

function RouteComponent() {
	return <MonitoringConfig />;
}
